export const Handles = {
  allProductsForDog: 'fur-hunde-alle-fleischsorten',
  allProductsForCat: 'fur-katzen-alle-fleischsorten',
} as const;
